import { ActionIcon, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import { ActionItem } from '../files-table/FilesTable';

type Props = {
  editAction: ActionItem<unknown> | null;
};

export default function EditDocumentControl({ editAction }: Props) {
  if (!editAction) return null;

  const disabled = editAction.disabled ?? false;
  const label = disabled ? (editAction.tooltip ?? 'Edit') : 'Edit';

  return (
    <Tooltip label={label} withArrow>
      <ActionIcon
        variant="subtle"
        c={disabled ? undefined : 'brand.7'}
        bg={disabled ? undefined : 'brand.0'}
        size={20}
        radius={8}
        aria-label="Edit document"
        data-disabled={disabled || undefined}
        onClick={e => {
          e.stopPropagation();
          if (disabled) {
            e.preventDefault();
            return;
          }
          editAction.action(undefined);
        }}
      >
        <IconEdit size={16} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
}
